import React from 'react';
import PropTypes from 'prop-types';
import { defaultAnswersSelector } from 'containers/QuestionnairePage/GenericQuestion/SingleMultipleQuestion/utils';
import QuestionFooter from 'containers/QuestionnairePage/GenericQuestion/QuestionFooter';
import { QUESTION_ICON_MAP } from 'containers/TemplatePreviewPage/QuestionsListViewOnly/GenericQuestionViewOnly/constants';
import QuestionPrompt from 'containers/TemplatePreviewPage/QuestionsListViewOnly/GenericQuestionViewOnly/QuestionPromptViewOnly';
import QuestionAnswerViewOnly from 'containers/TemplatePreviewPage/QuestionsListViewOnly/GenericQuestionViewOnly/QuestionAnswerViewOnly';

const SingleMultipleQuestionViewOnly = ({
  question,
  renderPrompt,
  attributes,
  hideActions = false,
}) => {
  const defaultAnswers = defaultAnswersSelector(question.answers);
  return (
    <div>
      <QuestionPrompt
        className="margin-btm-sm"
        icon={QUESTION_ICON_MAP[question.type]}
        renderPrompt={renderPrompt}
        questionIndex={question.questionIndex}
        label={question.label}
      />
      {defaultAnswers.map((answer, index) => (
        <QuestionAnswerViewOnly
          key={answer.refId}
          answer={answer}
          index={index + 1}
          hideActions={hideActions}
        />
      ))}
      <QuestionFooter
        key={`${question.refId}-${question.type}-footer`}
        type={question.type}
        label={question.label}
        goesTo={question.goesTo}
        goesToWithErrors={question.goesToWithErrors}
        comesFrom={question.comesFrom}
        isUnused={question.isUnused}
        invalidReferences={question.invalidReferences}
        invalidReferencesAnswersLogic={question.invalidReferencesAnswersLogic}
        invalidReferencesVariablesLogic={
          question.invalidReferencesVariablesLogic
        }
        media={question.media}
        shuffle={question.shuffle}
        ratingSize={question.ratingSize}
        selectedAttributes={question.selectedAttributes}
        answers={question.answers}
        attributes={attributes}
        hiddenVariables={question.hiddenVariables}
        readOnly
      />
    </div>
  );
};

SingleMultipleQuestionViewOnly.propTypes = {
  question: PropTypes.object.isRequired,
  renderPrompt: PropTypes.func.isRequired,
  attributes: PropTypes.array.isRequired,
  hideActions: PropTypes.bool,
};

export default SingleMultipleQuestionViewOnly;
